/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'config' implicitly has an 'any' type.
const CitationTrailLinks = (config, citationTrail, i18n, $searchTabs) => ({
   replace: true,
   templateUrl: '/assets/citationTrail/citationTrailLinks.html',

   scope: {
      citationDoc: '=',
      selectedTab: '=',
      callback: '&'
   },

   link(scope: any) {
      const doc = scope.citationDoc
      scope.i18n = i18n
      scope.citedBy = citationTrail.hasCitedBy(doc)
      scope.cites = citationTrail.hasCites(doc)

      scope.getCites = function() {
         citationTrail.reset({clearPath: scope.selectedTab === $searchTabs.search})
         citationTrail.getCites(doc)
         if (scope.callback) { return scope.callback() }
      }

      scope.getCitedBy = function() {
         citationTrail.reset({clearPath: scope.selectedTab === $searchTabs.search})
         citationTrail.getCitedBy(doc)
         if (scope.callback) { return scope.callback() }
      }

      // Space does not trigger a native click on the anchor, so handle it here.
      // Enter is handled by the global keyup handler which triggers a click.
      scope.getCitesOnSpace = function(event: any) {
         if (event.key === ' ' || event.key === 'Spacebar' || event.which === 32) {
            event.preventDefault()
            return scope.getCites()
         }
      }

      return scope.getCitedByOnSpace = function(event: any) {
         if (event.key === ' ' || event.key === 'Spacebar' || event.which === 32) {
            event.preventDefault()
            return scope.getCitedBy()
         }
      }
   }
})

const CitationTrailFeed = (citationTrail: any, config: ConfigService, $searchTabs: any) => ({
   replace: true,
   templateUrl: '/assets/citationTrail/citationTrailFeed.html',

   link(s: any) {
      s.inf = Infinity
      s.pageSize = config.data.results.pageSize
      s.retry = citationTrail.retry
      s.$searchTabs = $searchTabs
   }
})

const CitationTrailInfo = () => ({
   replace: true,
   templateUrl: '/assets/citationTrail/citationTrailInfo.html'
})

const CitationPath = function(citationTrail: any, i18n: any) {
   return {
      replace: true,
      templateUrl: '/assets/citationTrail/citationPath.html',
      link(scope: any, el: any, attrs: any) {
         // @ts-expect-error TS(2339) FIXME: Property 'maxItems' does not exist on type '{ repl... Remove this comment to see the full error message
         this.maxItems = 5
         scope.citationTrail = citationTrail.scope
         scope.i18n = i18n
         scope.selectWaypoint = citationTrail.selectWaypoint
         scope.onToggle = function(status: any) {
            if (status) {
               return scope.subMenu.citationPath.openMenu() 
            } else {
               return scope.subMenu.citationPath.closeMenu() 
            }
         }
         scope.showPath = (index: any) => {
            // @ts-expect-error TS(2339) FIXME: Property 'maxItems' does not exist on type '{ repl... Remove this comment to see the full error message
            return (index <= (this.maxItems - 1)) || (index === (scope.citationTrail.path.length - 1))
         }
         // @ts-expect-error TS(7023) FIXME: 'showKabob' implicitly has return type 'any' becau... Remove this comment to see the full error message
         return scope.showKabob = (index: any) => {
            // @ts-expect-error TS(2339) FIXME: Property 'maxItems' does not exist on type '{ repl... Remove this comment to see the full error message
            return !scope.showPath(index) && (index === this.maxItems)
         }
      }
   }
}

angular.module('summonApp.directives')
   .directive('citationTrailLinks', ['configService', 'citationTrailService', 'translationService', '$searchTabs', CitationTrailLinks])
   .directive('citationTrailFeed', ['citationTrailService', 'configService', '$searchTabs', CitationTrailFeed])
   .directive('citationTrailInfo', CitationTrailInfo)
   .directive('citationPath', ['citationTrailService', 'translationService', CitationPath])
